import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import { formatCurrency } from '../../common/formatting/number';
import { Button } from '../../../../components';

const ChangeFeeModal = ({ isOpen, onClose, paymentAmount, onSave }) => {
	const [newChargeAmount, setNewChargeAmount] = useState(0);
	const [refundReason, setRefundReason] = useState('');

	useEffect(() => {
		if (isOpen) {
			setNewChargeAmount(paymentAmount);
			setRefundReason('');
		}
	}, [isOpen]);

	const handleSave = () => {
		onSave({
			newChargeAmount,
			refundReason
		});
	};

	return (
		<Modal isOpen={isOpen} contentLabel="Change Fee" className="modal-dialog">
			<div className="modal-content">
				<div className="modal-header">
					<div className="clearfix">
						<div className="pull-right">
							<button className="btn btn-link" onClick={onClose}>
								<em className="fa fa-lg fa-times" />
							</button>
						</div>
						<h3 className="modal-title">
							Change Fee
						</h3>
					</div>
				</div>
				<div className="modal-body form-horizontal">
					<div className="form-group">
						<label className="col-lg-4 control-label">Current Fee</label>
						<div className="col-lg-8">
							<p className="form-control-static">{formatCurrency(paymentAmount)}</p>
						</div>
					</div>
					<div className="form-group">
						<label className="col-lg-4 control-label">New Fee</label>
						<div className="col-lg-8">
							<div className="input-group m-b">
								<span className="input-group-addon">$</span>
								<input
									type="text"
									className="form-control new-fee"
									value={newChargeAmount}
									onChange={({ target }) => setNewChargeAmount(target.value)}
								/>
							</div>
							<span className="help-block m-b-none">New fee cannot be higher than original fee.</span>
						</div>
					</div>
					<div className="form-group">
						<label className="col-lg-4 control-label">Refund Reason</label>
						<div className="col-lg-8">
							<textarea
								className="form-control refund-reason"
								value={refundReason}
								onChange={({ target }) => setRefundReason(target.value)}
							/>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<Button
						title="Cancel"
						large
						onClick={onClose}
					/>
					<Button
						title="OK"
						onClick={handleSave}
						large
						primary
						className="ml"
					/>
				</div>
			</div>
		</Modal>
	);
};

ChangeFeeModal.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	paymentAmount: PropTypes.number,
	onSave: PropTypes.func.isRequired,
};

export default ChangeFeeModal;
